<template>
  <div class="loading-container">
    <img
      src="@/assets/yellow_duck_large.webp"
      alt="Company Logo"
      :style="logoStyle"
    >
    <p class="loading-text">
      Getting Our Ducks In a Row
    </p>
    <div class="ducks-container">
      <img
        v-for="index in 3"
        :key="index"
        src="@/assets/duck_loading_icon_100.webp"
        alt="Loading duck"
        class="duck"
        :class="{ 'duck-bounce': activeDuck === index }"
      >
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from 'vue';

export default {
  name: 'DuckLoading',
  setup() {
    const activeDuck = ref(1);
    let intervalId;

    onMounted(() => {
      intervalId = setInterval(() => {
        activeDuck.value = (activeDuck.value % 3) + 1;
      }, 500);
    });

    onUnmounted(() => {
      clearInterval(intervalId);
    });

    const logoStyle = computed(() => ({
      width: 'clamp(300px, 50vw, 650px)',
      marginBottom: 'clamp(20px, 5vw, 40px)',
    }));

    return {
      activeDuck,
      logoStyle,
    };
  },
};
</script>

<style scoped>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #000;
  z-index: 9999;
  padding: 20px;
  box-sizing: border-box;
}

.loading-text {
  color: #fff;
  margin-bottom: clamp(20px, 5vw, 40px);
  font-size: clamp(1.2rem, 4vw, 2rem);
  font-weight: bold;
  text-align: center;
  padding: 0 20px;
}

.ducks-container {
  display: flex;
  align-items: flex-end;
}

.duck {
  width: clamp(60px, 10vw, 100px);
  height: auto;
  margin: 0 clamp(5px, 1vw, 10px);
  transition: all 0.3s ease-in-out;
}

.duck-bounce {
  transform: translateY(-5px) scale(1.1);
}
</style>

